<template>
  <nav class="riclothes-header" :class="{ dark: this.$root.config.isDarkTheme}">
    <RiClothesLogo class="riclothes-header--logo" />
    <div class="riclothes-header--container">
      <RiClothesButton text="ホーム" buttonType="text" color="blue" class="riclothes-header--button" router_to="/" />
      <RiClothesButton text="販売物配布物" buttonType="text" color="blue" class="riclothes-header--button" router_to="/product" />
      <!-- <RiClothesButton text="RiClothesSetuper" buttonType="text" color="blue" class="riclothes-header--button" disable="true" /> -->
    </div>
  </nav>
</template>

<script>
import RiClothesButton from "@/components/RiClothesButton.vue";
import RiClothesLogo from "@/components/RiClothesLogo.vue";

export default {
  name: "ri-clothes-header",
  components: {
    RiClothesButton,
    RiClothesLogo
  }
}
</script>

<style lang="scss" scoped>
.riclothes-header {
  --header-background-color: #ffffff;

  position: fixed;
  top: 0px;
  left: 0px;
  z-index: 4;
  display: flex;
  align-items: center;
  width: 100%;
  height: 64px;
  padding-right: 8px;
  padding-left: 8px;
  box-shadow: 0 2px 5px rgba(0,0,0,0.26);
  background-color: var(--header-background-color);
  overflow: auto;
  transition: 0.5s;

  &--logo {
    margin-left: 8px;
    height: 48px;
  }

  &--button {
    height: 50px;
    display: inline-block;
  }

  &--container {
    margin-left: auto;
    white-space: nowrap;
    overflow-x: auto;
  }
}

.dark {
  --header-background-color: #272727;
}

@media screen and (max-width: 896px) {
  .riclothes-header {
    height: 56px;

    &--logo {
      height: 40px;
    }

    &--button {
      height: 42px;
    }
  }
}
</style>